import {createFileRoute} from '@tanstack/react-router'
import LegalPage from "../landing/LegalPage.tsx";

export const Route = createFileRoute('/privacy')({
    component: RouteComponent,
})

function RouteComponent() {
    return <LegalPage />
}
